import React from 'react'
import { DateTime, Info } from 'luxon'

import SummarySaleReport from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleReport'
import SummarySaleDetail from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail'
import { OptionSelect } from '@components/OptionSelect/OptionSelect'
import { Button } from '@components/Buttons'
import { SaleSummaryProps } from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/interface'

const months = Info.months('long', { locale: 'th' }).map((name, i) => ({
  value: i + 1,
  label: name,
}))
const years = Array.from({ length: 10 }, (_, i) => {
  const date = Number(DateTime.now().toFormat('yyyy')) - i
  return {
    value: date,
    label: String(date),
  }
})
const SaleSummary = ({
  setYearSelected,
  setMonthSelected,
  monthSelected,
  yearSelected,
  handleQuery,
  dateSelected,
  exportFile,
  isLoading,
}: SaleSummaryProps) => {
  return (
    <div>
      <div className='flex mobile:flex-col justify-between desktop-tablet:space-x-[20px] mt-[20px]'>
        <div className='flex space-x-[20px]'>
          <OptionSelect
            className='w-[180px] mobile:w-full text-sm font-[300]'
            value={Number(monthSelected)}
            valueClassName='text-sm font-[300]'
            handleSelect={v => {
              setMonthSelected(v)
            }}
            options={months}
          />
          <OptionSelect
            className='w-[180px] mobile:w-full text-sm font-[300]'
            value={yearSelected}
            valueClassName='text-sm font-[300]'
            handleSelect={v => {
              setYearSelected(v)
            }}
            options={years}
          />
        </div>
        <div className='flex justify-between desktop-tablet:w-full mobile:space-x-[20px] mobile:mt-[20px]'>
          <Button
            className='font-mitr text-white dark:text-white-2 bg-primary dark:bg-purple desktop-tablet:min-w-[109px] mobile:w-full text-[14px] whitespace-nowrap'
            type='button'
            onClick={() => handleQuery()}
          >
            ยืนยัน
          </Button>
          <Button
            className='font-mitr text-white dark:text-white-2 bg-secondary dark:bg-purple w-[86px] text-[14px] whitespace-nowrap'
            type='button'
            onClick={exportFile}
            disabled={isLoading}
          >
            Export
          </Button>
        </div>
      </div>
      <SummarySaleReport dateSelected={dateSelected} />
      <SummarySaleDetail dateSelected={dateSelected} />
    </div>
  )
}

export default SaleSummary
